import * as a from "react";
var m = {
    setColorTheme: () => {}
  },
  c = a.createContext(m);
function i() {
  return a.useContext(c);
}
import * as t from "react";
var l = Object.freeze(["auto", "light-only", "dark-only"]),
  u = l[0],
  e = {
    COLOR: "@seed-design/scale-color",
    PLATFORM: "@seed-design/platform"
  };
function C(_ref) {
  let {
    mode: o = "auto"
  } = _ref;
  let [r, n] = t.useState(void 0),
    s = t.useMemo(() => ({
      setColorTheme: n
    }), []);
  return t.useEffect(() => {
    o !== "auto" && (document.documentElement.dataset.seed = o);
  }, []), t.useEffect(() => {
    document.documentElement.dataset.seedPlatform || (document.documentElement.dataset.seedPlatform = "ios");
  }, []), t.useEffect(() => {
    if (typeof window < "u") {
      let d = localStorage.getItem(e.COLOR);
      n(d || "system");
    }
  }, []), t.useEffect(() => {
    !r || (o === "auto" && (document.documentElement.dataset.seedScaleColor = r, r === "system" ? (window.matchMedia("(prefers-color-scheme: dark)").matches && (document.documentElement.dataset.seedScaleColor = "dark"), window.matchMedia("(prefers-color-scheme: light)").matches && (document.documentElement.dataset.seedScaleColor = "light"), localStorage.removeItem(e.COLOR)) : localStorage.setItem(e.COLOR, r)), o === "dark-only" && (document.documentElement.dataset.seedScaleColor = "dark", localStorage.setItem(e.COLOR, "dark")), o === "light-only" && (document.documentElement.dataset.seedScaleColor = "light", localStorage.setItem(e.COLOR, "light")));
  }, [r]), s;
}
var E = _ref2 => {
  let {
    mode: o = "auto"
  } = _ref2;
  return `
		(function(window, document, mode) {
			try {
				if (mode !== 'auto') {
					document.documentElement.dataset.seed = mode;
				}
			} catch (e) {}
			
			try {
				var color = window.localStorage.getItem('${e.COLOR}');
				if (color) {
					document.documentElement.dataset.seedScaleColor = color;
				} else {
					var prefersLight = window.matchMedia('(prefers-color-scheme: light)');
  				var prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
					if (prefersLight.matches) {
						document.documentElement.dataset.seedScaleColor = 'light';
						if ('addEventListener' in prefersLight) {
							prefersLight.addEventListener('change', apply);
						} else if ('addListener' in prefersLight) {
							prefersLight.addListener(apply);
						}
					} else if (prefersDark.matches) {
						document.documentElement.dataset.seedScaleColor = 'dark';
						if ('addEventListener' in prefersDark) {
							prefersDark.addEventListener('change', apply);
						} else if ('addListener' in prefersDark) {
							prefersDark.addListener(apply);
						}
					}
				}

				function apply() {
					document.documentElement.dataset.seedScaleColor = prefersDark.matches ? 'dark' : 'light';
					document.documentElement.dataset.seedScaleLetterSpacing = 'ios';
				}
			} catch (e) {}

			try {
				var platform = window.localStorage.getItem('${e.PLATFORM}');
				if (platform) {
					document.documentElement.dataset.seedPlatform = platform;
				} else if (typeof window.AndroidFunction !== 'undefined') {
					document.documentElement.dataset.seedPlatform = 'android';
				} else if (typeof window.webkit !== 'undefined' && typeof window.webkit.messageHandlers !== 'undefined') {
					document.documentElement.dataset.seedPlatform = 'ios';
				} else {
					document.documentElement.dataset.seedPlatform = 'ios';
				}
			} catch (e) {}
		})(window, document, '${o}');
	`;
};
export { l as ColorModeValues, u as DefaultColorModeValue, e as StorageKey, c as ThemeContext, E as generateNoFlashScript, i as useTheme, C as useThemeBehavior };